/* 🤖 this file was generated by svg-to-ts */
export const matIconImportExport: {
  name: 'import-export';
  data: string;
} = {
  name: 'import-export',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9 3 5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"/></svg>`
};
